import { Stack as ExpoRouterStack } from 'expo-router'
import type { ComponentProps, ReactNode } from 'react'

import { mergePageTypeScreenOptions, usePageTypeNavigator } from '@/src/general/hooks/usePageTypeNavigator'

type TExpoStackProps = ComponentProps<typeof ExpoRouterStack>

/**
 * expo-router Stack with page-type style baked in (opaque contentStyle + screenLayout).
 */
const PageTypeStackRoot = ({ screenLayout, screenOptions, ...props }: TExpoStackProps): ReactNode => {
  const { pageBackgroundColor, composeScreenLayout } = usePageTypeNavigator()

  return (
    <ExpoRouterStack
      {...props}
      screenLayout={composeScreenLayout(screenLayout)}
      screenOptions={mergePageTypeScreenOptions('contentStyle', pageBackgroundColor, screenOptions)}
    />
  )
}

export const Stack = Object.assign(PageTypeStackRoot, {
  Screen: ExpoRouterStack.Screen,
  Protected: ExpoRouterStack.Protected,
  Header: ExpoRouterStack.Header,
  SearchBar: ExpoRouterStack.SearchBar,
  Toolbar: ExpoRouterStack.Toolbar,
})
